function handle_error(xhr, status, error) {
	//Error Handler
	console.log("Ajax Failure");
	console.log(xhr.responseText);
	console.log(status);
	console.log(error);
	//Error Handler
}

export default handle_error;
